import { render, staticRenderFns } from "./CreateObject.vue?vue&type=template&id=135d9f7e&scoped=true&"
import script from "./CreateObject.vue?vue&type=script&lang=js&"
export * from "./CreateObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d9f7e",
  null
  
)

export default component.exports